import { Box } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"

export default function DataTable({columns, rows, onRowClick, loading, style, ...props}){
  return (
    <Box style={rows.length > 5 ? {} : {height: '50vh'}}>
      <DataGrid
        style={style}
        columns={columns}
        rows={rows}
        loading={loading}
        onRowClick={onRowClick}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 }
          }
        }}
        pageSizeOptions={[5, 10, 20, 25]}
        {...props}
      />
    </Box>
  )
}